export default function premade() {
    var productID = 31334,
        components = [
            {
                id: 11920,
                name: 'SmartGI&reg; Ultra Pellets ',
                isColiCareEligible: !0,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Digestive Enzymes',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#digestiveenzymes'
                        },
                        {
                            title: 'Fenugreek',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Fenugreek'
                        },
                        {
                            title: 'Glycine',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#glycine'
                        },
                        {
                            title: 'Hydrolyzed Collagen',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Collagen'
                        },
                        {
                            title: 'Lecithin',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#lecithin'
                        },
                        {
                            title: 'Oat Beta Glucan',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#BetaGlucan'
                        },
                        {
                            title: 'Pectin',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#pectin'
                        },
                        {
                            title: 'Prebiotics',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#prebiotics'
                        },
                        {
                            title: 'Probiotics',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#probiotics'
                        },
                        {
                            title: 'Psyllium',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#psyllium'
                        },
                        {
                            title: 'Silica',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#silica'
                        },
                        {
                            title: 'Yeast',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#yeast'
                        }
                    ],
                    clinicalResearchLink: '/LandingPgs/clinical-research-articles.html'
                },
                productLabelImage: {
                    type: 'label',
                    url:
                        '//img.smartpak.com/images/views/productclass/productlabel/21920_SmartGIUltraPellets_Label_3-2018.jpg',
                    attributes: null
                },
                productId: 2109746346
            },
            {
                id: 15237,
                name: 'SmartFlex&reg; Ultra Pellets',
                isColiCareEligible: !1,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Chondroitin Sulfate',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Chondroitin'
                        },
                        {
                            title: 'Glucosamine',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#glucosamine'
                        },
                        {
                            title: 'Hyaluronic Acid (HA)',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#hyaluronic'
                        },
                        {
                            title: 'Hydrolyzed Collagen',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Collagen'
                        },
                        {
                            title: 'MSM',
                            url: 'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#msm'
                        },
                        {
                            title: 'Silica',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#silica'
                        },
                        {
                            title: 'Vitamin C',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#vitaminC'
                        }
                    ],
                    clinicalResearchLink: ''
                },
                productLabelImage: {
                    type: 'label',
                    url: '//img.smartpak.com/images/views/productclass/productlabel/25237_SmartFlexUltra_6-2017.jpg',
                    attributes: null
                },
                productId: 2109781004
            }
        ],
        script = document.createElement('script');
    script.async = !0;
    script.onload = function() {
        window.premade(components, productID);
    };
    script.src = '/jsscripts/dycampaigns/premade.js';
    document.getElementsByTagName('head')[0].appendChild(script);
}